module.exports = __webpack_public_path__ + "static/health-smart-behavior-b640a058a0e263313717b93a171979fa.jpg";